// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumLock-cls1_Yj0","cls2":"PremiumLock-cls2_qBc PremiumLock-cls1_Yj0"};